// extracted by mini-css-extract-plugin
export default {"SiteHeader":"SiteHeader_SiteHeader__9U0D5","title":"SiteHeader_title__623j9"};